import { useEffect, useState } from 'react'

import clientAxios from '../config/axios'

const useBottler = () => {
  const [bottlers, setBottlers] = useState([])

  useEffect(() => {
    const consultApi = async () => {
      await clientAxios
        .get('/bottler/all')
        .then((response) => {
          setBottlers(response.data)
        })
        .catch((error) => {
          console.log(error)
        })
    }

    consultApi()
  }, [])

  return [bottlers]
}

export default useBottler
